import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as amplitude from '@amplitude/analytics-browser'
import { faUser } from "@fortawesome/free-regular-svg-icons";
import {
  faAdd,
  faBriefcase,
  faMobileScreen,
  faPerson,
  faRightFromBracket,
  faSearch,
  faUtensils,
  faFilter,
  faClose,
  faComments,
  faMessage,
  faPlus,
  faGem,
  faCamera,
  faUpload,
  faTimes,
  faPaperclip,
  faMagicWandSparkles,
} from "@fortawesome/free-solid-svg-icons";
import config from "../utils/config";
import { Player } from '@lottiefiles/react-lottie-player';
import loader from '../loader/loading_animation.json'

//
import "../css/components/MenuBar.css";

//
import CreatorData from "../data/creatorData";
import MenuDropdown from "./MenuDropdown";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../components/ui/dialog";
import PreferencesForm from "../pages/consumer/form.js";
import SearchTabs from "./SearchTabs";

//
import SmartRecipeService from "../services/smartrecipe.js";
import { ChevronRight, X, ChevronLeft } from "lucide-react";
import clsx from "clsx";

const cuisineOptions = [
  { id: "mexican", label: "Mexican" },
  { id: "german", label: "German" },
  { id: "chinese", label: "Chinese" },
  { id: "american", label: "American" },
  { id: "italian", label: "Italian" },
  { id: "japanese", label: "Japanese" },
  { id: "spanish", label: "Spanish" },
  { id: "korean", label: "Korean" },
  { id: "moroccan", label: "Moroccan" },
];

const ingredientOptions = [
  { id: "beef", label: "Beef" },
  { id: "pork", label: "Pork" },
  { id: "chicken", label: "Chicken" },
  { id: "tofu", label: "Tofu" },
  { id: "eggs", label: "Eggs" },
  { id: "seafood", label: "Seafood" },
  { id: "vegetables", label: "Vegetables" },
  { id: "pasta", label: "Pasta" },
];

const mealOptions = [
  { id: "quick", label: "30 Minute Meals" },

  { id: "breakfast", label: "Breakfast/Brunch" },
  { id: "lunch", label: "Lunch" },
  { id: "dinner", label: "Dinner" },
  { id: "desserts", label: "Desserts" },
  { id: "healthy", label: "Healthy" },
];

const dietOptions = [
  { id: "vegan", label: "Vegan" },
  { id: "vegetarian", label: "Vegetarian" },
  { id: "keto", label: "Keto" },
  { id: "paleo", label: "Paleo" },
  { id: "dairy free", label: "Dairy-Free" },
  { id: "gluten free", label: "Gluten-Free" },
  { id: "kosher", label: "Kosher" },
];

const creatorOptions = [
  { id: "Chris De La Rosa", label: "Chris De La Rosa" }
];

//

class MenuBar extends Component {
  menuData;

  constructor(props) {
    console.log("menubar > ctor");

    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.userMenuRef = React.createRef();
    this.searchBarRef = React.createRef();
    this.searchMenuRef = React.createRef();
    this.customMenuBtnRef = React.createRef();
    this.mobileSearchBtnRef = React.createRef();

    this.menuData = {
      creator: [
        {
          type: "link",
          name: "Dashboard",
          url: "/creator/dashboard",
        },
        {
          type: "link",
          name: "Your Recipes",
          url: "/creator/recipes",
        },
        {
          type: "link",
          name: "Marketplace",
          url: "/creator/marketplace",
        },
        {
          type: "link",
          name: "Sponsorships",
          url: "/creator/sponsorships",
        },
      ],
      brand: [
        {
          type: "link",
          name: "Dashboard",
          url: "/brand/dashboard",
        },
        {
          type: "divider",
        },
        {
          type: "link",
          name: "Recipes",
          url: "/brand/recipes",
        },
        {
          type: "divider",
        },
        {
          type: "link",
          name: "Manage Appliances",
          url: "/brand/appliances",
        },
        {
          type: "divider",
        },
        {
          type: "link",
          name: "Creators",
          url: "/brand/marketplace",
        },
        {
          type: "divider",
        },
        {
          type: "link",
          name: "Sponsorships",
          url: "/brand/sponsorships",
        },
        // {
        //     type: 'divider',
        // },
      ],
      consumer: [
        {
          type: "link",
          name: "All Recipes",
          url: "/consumer/recipes",
        },
        {
          type: "divider",
        },
       
        
        {
          type: "dropdown",
          id: "cuisines",
          name: "Cuisines",
          items: cuisineOptions,
        },
        {
          type: "dropdown",
          id: "diets",
          name: "Diets",
          items: dietOptions,
        },

        {
          type: "dropdown",
          id: "meals",
          name: "Meals",
          items: mealOptions,
        },
        {
          type: "dropdown",
          id: "ingredients",
          name: "Ingredients",
          items: ingredientOptions,
        },
        {
          type: "dropdown",
          id: "creators",
          name: "Creators",
          items: creatorOptions,
        },
        {
          type: "divider",
        },
        {
          type: "link",
          icon: faSearch,
          name: "Search",
          onClickHandler: () => this.handleSearchOnClick(),
          ref: this.searchMenuRef,
        },

        {
          type: "divider",
        },
        {
          type: "filter",
          icon: faFilter,
          name: "Preferences",
        },
      ],
    };

    this.state = {
      userMenuVisible: false,
      userMenuItems: this.getMenuItems(props.currentUserType),
      mobileMenu: this.getMobileMenuItems(props.currentUserType),
      isMobileMenuVisible: false,
      searchBarVisible: false,
      showError: false,
      preferences: 0,
      openDialog: false,
      loading: false,
      searchQuery: "",
      isMobile: false,
      isFeedbackFormVisible: false,
      searchMode: "full", // full or kitchen
      currentIngredient: "",
      ingredientsList: [],
      uploadedImage: null,
      imagePreview: null,
      isAnalyzingImage: false,
      showAnalysisAnimation: false,
    };
    
    this.fileInputRef = React.createRef();
  }
  componentDidMount() {
    if (window.innerWidth < 1024) {
      this.setState({
        isMobile: true,
      });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
      this.fetchSubscriptionDetails();
    
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.state.userMenuVisible === true &&
      this.userMenuRef &&
      !this.userMenuRef.current.contains(event.target)
    ) {
      this.setState({ userMenuVisible: false });
    }
    if (
      this.state.searchBarVisible === true &&
      this.searchBarRef &&
      !this.searchBarRef.current.contains(event.target) &&
      this.mobileSearchBtnRef &&
      !this.mobileSearchBtnRef.current.contains(event.target) &&
      this.searchMenuRef &&
      !this.searchMenuRef.current.contains(event.target)
    ) {
      const addMarginTopAndAnimationClass = document.getElementById("mainId");
      this.setState(
        {
          searchBarVisible: false,
        },
        () => {
          if (this.state.isMobile) {
            addMarginTopAndAnimationClass.style.marginTop = "5rem";
          } else {
            addMarginTopAndAnimationClass.style.marginTop = "7rem";
          }
        }
      );
    }
  };

  handleMenuOptionClick = (menuId, optionId) => {
    //console.log('handleMenuOptionClick: ', menuId, optionId);
    this.setState({ dropdownMenuVisible: false, searchBarVisible: false });
    if (menuId === "cuisines")
      this.props.navigate(
        `../${this.props.currentUserType}/recipes/cuisines/${optionId}`
      );
    if (menuId === "diets")
      this.props.navigate(
        `../${this.props.currentUserType}/recipes/diets/${optionId}`
      );
    if (menuId === "meals")
      this.props.navigate(
        `../${this.props.currentUserType}/recipes/meals/${optionId}`
      );
    if (menuId === "ingredients")
      this.props.navigate(
        `../${this.props.currentUserType}/recipes/ingredients/${optionId}`
      );
    if (menuId === "creators")
      this.props.navigate(
        `../${this.props.currentUserType}/recipes/creator/chris-de-la-rosa`
      );
  };

  //

  handleManageProfile = (userType) => {
    this.setState({ userMenuVisible: false });
    this.props.navigate("../" + userType + "/profile/edit");
  };

  handleManageDevices = (userType) => {
    this.setState({ userMenuVisible: false });
    this.props.navigate("../" + userType + "/devices/manage");
  };

  handleLogoutClick = () => {
    this.setState({ userMenuVisible: false });
    this.props.logoutFunc();
    this.props.navigate("../");
  };

  handleUserMenuButtonClick = () => {
    //console.log({msg:'handleUserMenuButtonClick', 'userMenuVisible':this.state.userMenuVisible});
    this.setState({ userMenuVisible: !this.state.userMenuVisible });
  };

  handleUserMenuOptionClick = (userType) => {
    //console.log({msg:'handleUserMenuOptionClick', 'userMenuVisible':this.state.userMenuVisible});
    this.setState({
      userMenuVisible: false,
      userMenuItems: this.getMenuItems(userType),
    });
    this.props.setUserTypeFunc(userType);
    if (userType === "consumer") {
      this.props.navigate("../" + userType + "/recipes");
    } else {
      this.props.navigate("../" + userType + "/dashboard");
    }
  };

  handleMenuClick = () => {
    //console.log('handleMenuClick');
    this.setState({ searchBarVisible: false });
  };

  handleSearchOnClick = () => {
    console.log(
      { msg: "search", state: this.state.searchBarVisible },
      "sdaijgadi"
    );
    const addMarginTopAndAnimationClass = document.getElementById("mainId");
    this.setState(
      {
        searchBarVisible: !this.state.searchBarVisible,
        isMobileMenuVisible: false,
      },
      () => {
        if (this.state.searchBarVisible) {
          if (this.state.isMobile) {
            addMarginTopAndAnimationClass.style.marginTop = "11rem";
          } else {
            addMarginTopAndAnimationClass.style.marginTop = "20rem";
          }
        } else {
          if (this.state.isMobile) {
            addMarginTopAndAnimationClass.style.marginTop = "5rem";
          } else {
            addMarginTopAndAnimationClass.style.marginTop = "7rem";
          }
        }
      }
    );
  };

  handleFeedbackButtonClick = () => {
    this.setState({
      isFeedbackFormVisible: !this.state.isFeedbackFormVisible,
    });
  };

  handleSearchEntry = (e) => {
    //this.setState({searchQuery:e.target.value});
    //this.props.navigate(`../${this.props.currentUserType}/recipes?search=${e.target.value}`);
  };

  handleSearchOnSubmit = async (e) => {
    const addMarginTopAndAnimation = document.getElementById("mainId");
    if (this.state.isMobile) {
      addMarginTopAndAnimation.style.marginTop = "5rem";
    } else {
      addMarginTopAndAnimation.style.marginTop = "7rem";
    }
    let query;
    if (typeof e == "object") {
      e.preventDefault(); // prevent the default form submission behavior
      query = e.target.value;
    } else {
      query = `${e}`;
    }
    //amplitude
    amplitude.logEvent('Recipe Search', {
      search_query: query,
      user_id: localStorage.getItem('userId') || 'guest',
      auth_status: localStorage.getItem('userId') ? 'authenticated' : 'unauthenticated',
      search_type: this.isUrlValid(query) ? 'URL' : 'keyword',
    });
    const checkIfqueryisUrl = this.isUrlValid(query);
    console.log(checkIfqueryisUrl);
    if (checkIfqueryisUrl == true) {
      const checkifUrlisfromSupportedWebsites = this.isValidWebsite(query);
      if (checkifUrlisfromSupportedWebsites == true) {
        this.setState({
          loading: true,
        });
        console.log("not here");
        const responses = await fetch(
          `${config.AI_BASE_URL}/backend/scrap_recipe`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              key: config.AI_API_KEY,
              recipe_url: query,
            }),
          }
        );
        const final = await responses.json();
        console.log(final, "final is ");
        if (final.status == 200) {
          if (Object.keys(final.recipe_data[1]).length == 0) {
            this.showError();
          }

          setTimeout(async () => {
            const getRecipeId = await SmartRecipeService.getNewRecipeid(
              final.recipe_data.recipe_id
            );

            if (getRecipeId.copied_recipe_id != undefined) {
              window.location.href = `/consumer/recipes/${getRecipeId.copied_recipe_id}/view`;
            } else {
              window.location.href = `/consumer/recipes`;
            }
          }, 3000);
        } else {
          this.showError();
        }
        return;
      } else {
        console.log(" here");

        this.setState({
          showError: true,
        });
        setTimeout(() => {
          this.setState({
            showError: false,
          });
        }, 2500);
        return;
      }
    } else {
      const url = query
        ? `../${this.props.currentUserType}/recipes/search/${query}`
        : `../${this.props.currentUserType}/recipes`;
      this.props.navigate(url);
      //this.setState({ searchBarVisible: false, searchQuery: query });
      this.setState({ searchBarVisible: false, searchQuery: undefined });
    }
  };
  showError() {
    this.setState({
      loading: false,
      showError: true,
    });
    setTimeout(() => {
      this.setState({
        showError: false,
      });
    }, 2500);
    return;
  }
  isUrlValid(userInput) {
    var res = userInput.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    if (res == null) return false;
    else return true;
  }

  toggleMenu() {
    this.setState({
      searchBarVisible: false,
    });
    this.setState({
      isMobileMenuVisible: !this.state.isMobileMenuVisible,
    });
    // var menuContainer = document.querySelector('.mobile-custom-menu');
    // menuContainer.classList.toggle('-translate-x-full');
  }

  toggleSubMenu(index) {
   
    var subMenu = document.getElementById("sub-menu-" + index);
    subMenu.classList.toggle("translate-x-full");
  }

  handleToggleSearchMode = () => {
    this.setState((prevState) => ({
      searchMode: prevState.searchMode === "full" ? "kitchen" : "full",
      searchQuery: "",
      ingredientsList: [],
    }));
  };
  
  handleRemoveIngredient = (index) => {
    const updatedIngredientsList = [...this.state.ingredientsList];
    updatedIngredientsList.splice(index, 1);
    this.setState({ ingredientsList: updatedIngredientsList });
  };
  
  handleSearchByIngredients = () => {
    const { ingredientsList, currentIngredient } = this.state;
    this.setState({
      searchBarVisible: false,
    });
    
    const addMarginTopAndAnimation = document.getElementById("mainId");
    if (this.state.isMobile) {
      addMarginTopAndAnimation.style.marginTop = "5rem";
    } else {
      addMarginTopAndAnimation.style.marginTop = "7rem";
    }
  
    // First check if there's anything in the current input that should be included
    let allIngredients = [...ingredientsList];
    if (currentIngredient && currentIngredient.trim() !== "") {
      // Add current input to the ingredients list
      const newIngredients = currentIngredient.split(',')
        .map(item => item.trim().toLowerCase())
        .filter(item => item !== "");
      
      allIngredients = [...allIngredients, ...newIngredients];
    }
  
    // Construct the query parameter from all ingredients
    const queryParams = allIngredients.length > 0
      ? `?ingredients=${allIngredients.join(',')}`
      : "";
  
    // Navigate to the new URL
    window.location.href = `/search${queryParams}`;
  };
  
  handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please select a valid image file');
        return;
      }
      
      // Show processing message for large files
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 5) {
        console.log('Processing large image, this may take a moment...');
      }

      this.setState({ uploadedImage: file });
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ imagePreview: e.target.result });
        if (fileSizeInMB > 5) {
          console.log('Large image processed successfully!');
        }
      };
      reader.readAsDataURL(file);
    }
  };

  handleRemoveImage = () => {
    this.setState({
      uploadedImage: null,
      imagePreview: null,
    });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  handleAnalyzeImage = async () => {
    if (!this.state.uploadedImage) return;
    
    this.setState({ isAnalyzingImage: true, showAnalysisAnimation: true });
    
    try {
      // Compress image before sending
      const compressedImage = await this.compressImage(this.state.uploadedImage);
      
      const response = await fetch(`${config.API_SERVER_URL}/api/v3/extract-ingredients`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          base64Image: compressedImage
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('API Response:', data);
      
      // Check for error response (improved error handling)
      if (!data.success || data.error) {
        console.error('API Error:', data.error);
        
        // Check for various error message formats
        const errorMessage = data.error || 'Unknown error';
        const isNotRecipeError = errorMessage.toLowerCase().includes('not a recipe') || 
                                errorMessage.toLowerCase().includes('not suitable') ||
                                errorMessage.toLowerCase().includes('no valid ingredients');
        
        if (isNotRecipeError) {
          alert('This image doesn\'t appear to contain recipe ingredients. Please upload an image of food ingredients or a recipe.');
        } else {
          alert(`Error: ${errorMessage}`);
        }
        
        this.setState({ isAnalyzingImage: false, showAnalysisAnimation: false });
        return;
      }
      
      // Extract ingredients from API response
      if (data.ingredients && Array.isArray(data.ingredients) && data.ingredients.length > 0) {
        const newIngredients = [...this.state.ingredientsList];
        
        // Process the clean ingredients from the improved backend
        data.ingredients.forEach(ingredientName => {
          // Remove any remaining quotes and clean the ingredient name
          const cleanIngredient = ingredientName
            .replace(/"/g, '') // Remove any quotes
            .trim()
            .toLowerCase();
          
          if (cleanIngredient && !newIngredients.includes(cleanIngredient)) {
            newIngredients.push(cleanIngredient);
          }
        });
        
        // Show success animation for 2 seconds then navigate
        setTimeout(() => {
          this.setState({ 
            isAnalyzingImage: false, 
            showAnalysisAnimation: false,
            searchBarVisible: false 
          });
          
          // Navigate to search results with ingredients
          const queryParams = newIngredients.length > 0
            ? `?ingredients=${newIngredients.join(',')}`
            : "";
          
          window.location.href = `/search${queryParams}`;
        }, 2000);
        
        console.log('Raw API ingredients:', data.ingredients);
        console.log('Cleaned ingredients:', newIngredients);
        console.log('Final ingredients added:', newIngredients.filter(ing => !this.state.ingredientsList.includes(ing)));
        
      } else {
        console.warn('No ingredients found in API response');
        alert('No ingredients could be identified in this image. Please try a different image.');
        this.setState({ isAnalyzingImage: false, showAnalysisAnimation: false });
      }
      
    } catch (error) {
      console.error('Error analyzing image:', error);
      if (error.message.includes('413') || error.message.includes('Payload Too Large')) {
        alert('Image is too large. Please try a smaller image or compress it first.');
      } else {
        alert('Failed to analyze image. Please check your connection and try again.');
      }
      this.setState({ isAnalyzingImage: false, showAnalysisAnimation: false });
    }
  };

  // Helper function to compress image
  compressImage = (file) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        // Start with aggressive compression for very large images
        let maxSize = 800;
        let quality = 0.7;
        
        // If original image is very large, be more aggressive
        if (img.width > 2000 || img.height > 2000) {
          maxSize = 600;
          quality = 0.5;
        }
        if (img.width > 4000 || img.height > 4000) {
          maxSize = 400;
          quality = 0.3;
        }
        
        // Calculate new dimensions
        let { width, height } = img;
        
        if (width > height) {
          if (width > maxSize) {
            height = (height * maxSize) / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width = (width * maxSize) / height;
            height = maxSize;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Draw and compress
        ctx.drawImage(img, 0, 0, width, height);
        
        // Progressive compression - keep reducing quality until size is acceptable
        const tryCompress = (currentQuality) => {
          const compressedDataUrl = canvas.toDataURL('image/jpeg', currentQuality);
          
          // Check if compressed size is acceptable (aim for under 2MB base64)
          const sizeInBytes = (compressedDataUrl.length * 3) / 4;
          const sizeInMB = sizeInBytes / (1024 * 1024);
          
          if (sizeInMB > 2 && currentQuality > 0.1) {
            // Still too large, reduce quality further
            return tryCompress(currentQuality - 0.1);
          } else {
            // Size is acceptable or we've reached minimum quality
            resolve(compressedDataUrl);
          }
        };
        
        tryCompress(quality);
      };
      
      img.src = URL.createObjectURL(file);
    });
  };

  // Helper function to extract ingredient name from full description
  extractIngredientName = (ingredientLine) => {
    if (!ingredientLine || typeof ingredientLine !== 'string') return '';
    
    // Remove quantities and measurements, extract the main ingredient
    let ingredient = ingredientLine.toLowerCase().trim();
    
    // Remove common measurements and quantities
    ingredient = ingredient
      .replace(/^\d+(\.\d+)?\s*(cups?|tablespoons?|teaspoons?|tbsp|tsp|lbs?|pounds?|ounces?|oz|grams?|g|ml|liters?|l)\s*/i, '')
      .replace(/^\d+(\.\d+)?\s*/i, '') // Remove leading numbers
      .replace(/,.*$/, '') // Remove everything after comma (like ", sliced", ", softened")
      .replace(/\s+(sliced|diced|chopped|minced|softened|melted|fresh|dried|ground|whole|large|small|medium).*$/i, '')
      .trim();
    
    // Take the main ingredient (first few words)
    const words = ingredient.split(' ');
    if (words.length > 3) {
      ingredient = words.slice(0, 3).join(' ');
    }
    
    return ingredient;
  };

  //

  getMenuItems(currentUserType) {
    console.log({ msg: "getMenuItems", menus: this.menuData });

    const curPath = this.props.location.pathname;
    const menuEntries = Object.assign([], this.menuData[currentUserType]);

    // config toggle to hide/show Add Recipe link
    // if (currentUserType === 'consumer' && config.ENABLE_ADD_RECIPE) {
    //     menuEntries.push(
    //         {
    //             type: 'divider',
    //         },
    //         {
    //             type: 'link',
    //             name: 'Add a recipe',
    //             icon: faAdd,
    //             url: '/consumer/recipes/create',
    //             onClickHandler: () => this.handleMenuClick(),
    //         }
    //     );
    // }

    return menuEntries.map((item, index) => {
      switch (item.type) {
        case "link":
          const linkClass =
            currentUserType !== "consumer" && curPath.indexOf(item.url) >= 0
              ? "selected"
              : "";
          const itemIconHtml = item.icon ? (
            <FontAwesomeIcon className="menuIcon text-white" icon={item.icon} />
          ) : (
            <></>
          );
          const itemNameHtml =
            item.name === "Search" ? (
              <span className="lg:hidden xl:block">{item.name}</span>
            ) : (
              item.name
            );
          return (
            <Link
              key={`menu-item-${index}`}
              to={item.url ? item.url : null}
              ref={item.ref ? item.ref : null}
              onClick={item.onClickHandler ? item.onClickHandler : null}
              className={`flex items-center text-white text-center ${linkClass}`}
            >
              {itemIconHtml}
              {itemNameHtml}
            </Link>
          );
        case "divider":
          return (
            <span
              key={`menu-item-${index}`}
              className="menuDivider hidden lg:block"
            ></span>
          );
        case "filter":
          const linkClass2 =
            currentUserType !== "consumer" && curPath.indexOf(item.url) >= 0
              ? "selected"
              : undefined;
          const itemIconHtML2 = item.icon ? (
            <img
              style={{
                height: "20px",
                display: "inline",
                marginRight: "6px",
              }}
              src="/filters.png"
            />
          ) : (
            <></>
          );
          return (
            <div>
              <Dialog
                className="min-w-[50vw]"
                id="dialog-trigger"
                style={{
                  background: "#f5f5f5",
                  overflowY: "scroll !important",
                }}
              >
                <DialogTrigger>
                  <div
                    onClick={() => {
                      this.setState({
                        searchBarVisible: false,
                      });
                    }}
                    className="bg-gray-200 px-[13px] py-[6px] rounded-[4px] flex flex-column justify-center cursor-pointer preferences-menu-btn"
                  >
                    <img
                      src="/filters.png"
                      alt=""
                      style={{
                        display: "inline-block",
                        height: "15px",
                        marginRight: "5px",
                        marginTop: "3.8px",
                      }}
                    />
                    {item.name}
                  </div>
                </DialogTrigger>
                <DialogContent
                  className="w-[90%] min-w-[60vw] lg:max-w-screen-lg overflow-y-scroll h-[65%] md:h-[85vh] max-h-screen"
                  style={{
                    background: "#f5f5f5",
                    overflowY: "scroll !important",
                    // height: '85vh',
                    marginTop: "35px",
                    zIndex: 999,
                  }}
                >
                  <DialogHeader>
                    {/* <DialogTitle></DialogTitle> */}
                    <DialogDescription className="mt-4">
                      <PreferencesForm onSubmit={() => this.LoginFunc()} />
                    </DialogDescription>
                  </DialogHeader>
                </DialogContent>
              </Dialog>
            </div>
          );
        case "dropdown":
          return (
            <MenuDropdown
              key={`menu-item-${index}`}
              id={item.id}
              items={item.items}
              onClick={this.handleMenuClick}
              handleOptionClick={this.handleMenuOptionClick}
            >
              {item.name}
            </MenuDropdown>
          );
        default:
          return <></>;
      }
    });
  }

  getMobileMenuItems(currentUserType) {
    const curPath = this.props.location.pathname;
    const menuEntries = Object.assign([], this.menuData[currentUserType]);
    return menuEntries.map((item, index) => {
      if (item.type !== "divider") {
        switch (item.type) {
          case "link":
            if (item.name !== "Search") {
              const linkClass =
                currentUserType !== "consumer" && curPath.indexOf(item.url) >= 0
                  ? "selected"
                  : undefined;
              const itemIconHtml = item.icon ? (
                <FontAwesomeIcon className="mr-2" icon={item.icon} />
              ) : (
                <></>
              );
              const itemNameHtml =
                item.name === "Search" ? (
                  <span className="lg:hidden xl:block">{item.name}</span>
                ) : (
                  item.name
                );
              return (
                <>
                  <div className="flex items-center justify-center gap-4">
                    <div
                      id="manage-devices"
                      className="final-click flex flex-col gap-1 items-center text-xl"
                      onClick={() => this.handleManageDevices(currentUserType)}
                    >
                      <FontAwesomeIcon
                        icon={faUtensils}
                        className="text-yellow-500"
                        style={{ width: "24px", marginRight: "8px" }}
                      />
                      <span className="text-sm">My Kitchen</span>
                    </div>
                    <div
                      className="final-click flex flex-col gap-1 items-center p-4 text-xl"
                      onClick={this.handleFeedbackButtonClick}
                    >
                      <FontAwesomeIcon
                        className="mr-2 text-yellow-500"
                        icon={faMessage}
                      />
                      <span className="text-sm">Feedback</span>
                    </div>
                  </div>
                  <Link
                    key={`menu-item-${index}`}
                    to={item.url ? item.url : null}
                    ref={item.ref ? item.ref : null}
                    onClick={item.onClickHandler ? item.onClickHandler : null}
                    className={`final-click flex items-center p-4 text-lg ${linkClass}`}
                  >
                    {itemIconHtml}
                    {itemNameHtml}
                  </Link>
                </>
              );
            }
            break;
          case "filter":
            return (
              <div className="p-4" key={index}>
                <div
                  id="logout"
                  onClick={() => this.handleLogoutClick()}
                  className="flex items-center justify-between text-lg"
                >
                  Logout
                  <ChevronRight />
                </div>
                <Dialog
                  className="min-w-[50vw]"
                  id="dialog-trigger"
                  style={{
                    background: "#f5f5f5",
                    overflowY: "scroll !important",
                  }}
                >
                  <DialogTrigger>
                    <div
                      onClick={() => {
                        this.setState({
                          searchBarVisible: false,
                        });
                      }}
                      className="final-click bg-white text-black items-center px-[13px] py-[6px] rounded-[4px] flex flex-column justify-center cursor-pointer preferences-menu-btn h-8 text-lg mt-8"
                    >
                      <img
                        src="/filters.png"
                        alt=""
                        style={{
                          display: "inline-block",
                          height: "15px",
                          marginRight: "5px",
                          marginTop: "3.8px",
                        }}
                      />
                      {item.name}
                    </div>
                  </DialogTrigger>
                  <DialogContent
                    className="w-[100%] min-w-[60vw] lg:max-w-screen-lg overflow-y-scroll h-[93%] md:h-[85vh] max-h-screen"
                    style={{
                      background: "#f5f5f5",
                      overflowY: "scroll !important",
                      // height: '85vh',
                      marginTop: "45px",
                      zIndex: 999,
                    }}
                  >
                    <DialogHeader>
                      {/* <DialogTitle></DialogTitle> */}
                      <DialogDescription className="mt-4">
                        <PreferencesForm onSubmit={() => this.LoginFunc()} />
                      </DialogDescription>
                    </DialogHeader>
                  </DialogContent>
                </Dialog>
              </div>
            );
          case "dropdown":
            return (
              <React.Fragment key={index}>
                <div className="p-4">
                  <p
                    onClick={() => { 
                    
                      this.toggleSubMenu(index)}}
                    className="flex items-center justify-between text-lg"
                  >
                    {item.name} <ChevronRight />
                  </p>
                </div>
                {typeof item.items !== typeof undefined && (
                  <div
                    id={`sub-menu-${index}`}
                    className="flex flex-col w-72 fixed h-screen overflow-y-scroll bg-white text-black text-lg top-0 translate-x-full transition-transform duration-500 z-20"
                  >
                    <div className="flex justify-between items-center p-4">
                      <div
                        className="w-1/2"
                        onClick={() => {
                          
                          this.toggleSubMenu(index)}}
                      >
                        <ChevronLeft />
                      </div>
                      <p className="w-full text-[#0e4621] font-bold">
                        {item.name}
                      </p>
                      <p>
                        <X
                          onClick={() => {
                            this.toggleSubMenu(index);
                            this.toggleMenu();
                          }}
                        />
                      </p>
                    </div>
                    {item.items.map((itemInside, indexInside) => {
                      return (
                        <div
                          className="p-4 border-b-2 py-6"
                          key={`menu-item-${indexInside}`}
                        >
                          <Link
                            to={`${this.props.currentUserType}/recipes/${item.id}/${itemInside.id}`}
                            className="final-click"
                            dataid={index}
                          >
                            {itemInside.label}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                )}
              </React.Fragment>
            );
          default:
            return <React.Fragment key={index}></React.Fragment>;
        }
      }
    });
  }

  isValidWebsite(url) {
    const trimmedUrl = url.trim();

    const allowedDomains = [
      "google\\.com",
      "www\\.marthastewart\\.com",
      "www\\.foodnetwork\\.com",
      "barefootcontessa\\.com",
      "lechefswife\\.com",
    ];

    const regex = new RegExp(
      `^(https?:\\/\\/)(www\\.)?(${allowedDomains.join("|")})(\\/.*)?`,
      "i"
    );

    return regex.test(trimmedUrl);
  }
  fetchSubscriptionDetails = async () => {
    try {
      const response = await fetch(`${config.API_SERVER_URL}/api/v3/details`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('userToken')}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        // Store subscription details in localStorage
        localStorage.setItem('subscriptionDetails', JSON.stringify(data));
        // Force a re-render to update the UI
        this.setState({ subscriptionUpdated: true });
      }
    } catch (error) {
      console.error('Error fetching subscription:', error);
    }
  };
  getProfileMenuHtml(
    currentUser,
    currentUserType,
    name,
    handle,
    profileImageUrl
  ) {
    console.log(this.props.currentUser, "dguiuo");
    const userMenuVisible = this.state.userMenuVisible ? "visible" : undefined;

    
    const creatorOptionSelected =
    currentUserType === "creator" ? "selected" : undefined;
  const brandOptionSelected =
    currentUserType === "brand" ? "selected" : undefined;
  const consumerOptionSelected =
    currentUserType === "consumer" ? "selected" : undefined;

  const consumerMenuItems =
    currentUser.roles.includes("consumer") && consumerOptionSelected ? (
      <>
        {/* {config.ENABLE_MY_PROFILE && !this.props.currentUser.guest ? <li id='manage-profile' onClick={() => this.handleManageProfile(currentUserType)}><FontAwesomeIcon icon={faUser} style={{ width: "24px", marginRight: "8px", color: "grey" }} />My Profile</li> : <></>} */}
        {/* {<li id='manage-devices' className="final-click" onClick={() => this.handleManageDevices(currentUserType)}><FontAwesomeIcon icon={faUtensils} style={{ width: "24px", marginRight: "8px", color: "grey" }} />My Kitchen</li>} */}
        {config.ENABLE_MY_KITCHEN || config.ENABLE_MY_PROFILE ? (
          <div
            style={{
              marginLeft: "12px",
              marginRight: "12px",
              height: "1px",
              borderTop: "1px solid #ccc",
            }}
          ></div>
        ) : (
          <></>
        )}
        {(() => {
          // Get subscription details from localStorage
          const subscriptionStr = localStorage.getItem('subscriptionDetails');
          let subscription = null;
          try {
            if (subscriptionStr) {
              subscription = JSON.parse(subscriptionStr);
            }
          } catch (e) {
            console.error('Error parsing subscription details', e);
          }
          
          return (
            <>
              {/* <li className="px-4 py-3" onClick={() => window.location.href = '/subscription/checkout'}>
                <div className="flex items-center">
                  <FontAwesomeIcon 
                    icon={faGem} 
                    style={{ 
                      width: "24px", 
                      marginRight: "8px", 
                      color: subscription?.status === 'active' ? "#DAA520" : "grey" 
                    }} 
                  />
                  <div>
                    <span className="block text-sm font-medium">Subscription</span>
                    {subscription?.status === 'active' ? (
                      <span className="text-green-600">Premium {subscription?.plan || ''}</span>
                    ) : (
                      <span className="text-gray-600">Free Trial</span>
                    )}
                  </div>
                </div>
              </li> */}
              <div
                style={{
                  marginLeft: "12px",
                  marginRight: "12px",
                  height: "1px",
                  borderTop: "1px solid #ccc",
                }}
              ></div>
            </>
          );
        })()}
        <li
          className={`final-click flex items-center p-4 text-lg`}
          onClick={this.handleFeedbackButtonClick}
        >
          <FontAwesomeIcon
            className="mr-2 text-yellow-300"
            icon={faComments}
          />
          Feedback
        </li>
      </>
    ) : (
      <></>
    );

  const adminMenuItems = currentUser.roles.includes("admin") ? (
    <>
      <li
        id="consumer"
        className={consumerOptionSelected}
        onClick={() => this.handleUserMenuOptionClick("consumer")}
      >
        <FontAwesomeIcon icon={faPerson} className="user-menu-icon" />
        Consumer
      </li>
      <li
        id="brand"
        className={brandOptionSelected}
        onClick={() => this.handleUserMenuOptionClick("brand")}
      >
        <FontAwesomeIcon icon={faBriefcase} className="user-menu-icon" />
        Brand
      </li>
      <li
        id="creator"
        className={creatorOptionSelected}
        onClick={() => this.handleUserMenuOptionClick("creator")}
      >
        <FontAwesomeIcon icon={faMobileScreen} className="user-menu-icon" />
        Creator
      </li>
      <div
        style={{
          marginLeft: "12px",
          marginRight: "12px",
          height: "1px",
          borderTop: "1px solid #ccc",
        }}
      ></div>
    </>
  ) : (
    <></>
  );

  const userMenu = (
    <ul className={userMenuVisible}>
      {consumerMenuItems}
      {adminMenuItems}
      <li id="logout" onClick={() => this.handleLogoutClick()}>
        <FontAwesomeIcon
          icon={faRightFromBracket}
          style={{ width: "24px", marginRight: "8px", color: "#cc0000" }}
        />
        Logout
      </li>
    </ul>
  );

  const profileImageStyle =
    consumerOptionSelected || creatorOptionSelected
      ? "user-profile-image"
      : "brand-profile-image";

  return (
    <div>
      <div
        className="lg:mt-0 mt-2 user-menu cursor-pointer hidden lg:block"
        ref={this.userMenuRef}
      >
        <div
          className={clsx([
            "flex p-3 rounded-full items-center lg:flex-row-reverse",
            {
              "user-menu-button": !this.state.isMobile,
            },
          ])}
          onClick={this.handleUserMenuButtonClick}
        >
          <img
            className={`${profileImageStyle}`}
            src={profileImageUrl}
            alt="My Profile"
          />
          {userMenu}
          <div className="user-info">
            <div className="user-name text-[12pt] text-white text-left lg:text-right">
              {name}
            </div>
            <div className="user-handle text-white lg:hidden xl:block">
              {handle}
            </div>
          </div>
        </div>
      </div>
      <div className="lg:mt-0 mt-2 user-menu cursor-pointer lg:hidden">
        <div
          className={clsx([
            "flex p-3 rounded-full items-center lg:flex-row-reverse",
            {
              "user-menu-button": !this.state.isMobile,
            },
          ])}
        >
          <img
            className={`${profileImageStyle}`}
            src={profileImageUrl}
            alt="My Profile"
          />
          {userMenu}
          <div className="user-info">
            <div className="user-name text-[12pt] text-white text-left lg:text-right">
              {name}
            </div>
            <div className="user-handle text-white lg:hidden xl:block">
              {handle}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

handleLeftSideFixedMobileMenuClick = (e) => {
  if (
    e.target.classList.contains("final-click") ||
    e.target.parentNode.classList.contains("final-click")
  ) {
    this.toggleMenu();
    if (e.target.getAttribute("dataid")) {
      this.toggleSubMenu(e.target.getAttribute("dataid"));
    }
  }
};

//

render() {
  const { currentUserType, currentUser, currentTenant, currentCreatorId } =
    this.props;

  //console.log({msg:'render', currentUser, currentTenant, currentUserType});

  const currentCreator = CreatorData[currentCreatorId];
  const currentCreatorName = currentCreator.name;
  const currentCreatorHandle = `@${currentCreator.handle}`;
  const currentCreatorImageUrl = `/user-logo-zoe.png`;

  const currentBrandName = currentTenant.name || "unknown";
  const currentBrandHandle = `@${currentTenant.brandData.handle}`;
  const currentBrandImageUrl = `/brands/${currentTenant.id}.png`;

  const currentUserName = currentUser ? currentUser.name : "Unknown";
  const currentUserHandle = currentUser.guest
    ? ""
    : currentUser?.email
    ? currentUser.email.toLowerCase()
    : "Unknown";
  const currentUserImageUrl = currentUser?.profileImage
    ? `/users/${currentUser?.profileImage}`
    : "/users/user-logo.png";

  //

  const menuItemsHtml = this.state.userMenuItems;
  const mobileMenuItemsHtml = this.state.mobileMenu;

  const addContentButtonHtml =
    currentUserType === "creator" ? (
      <Link to={`/${currentUserType}/recipes/create`}>
        <button className="gold" style={{ marginRight: "52px" }}>
          + Add Content
        </button>
      </Link>
    ) : (
      <></>
    );

  const profileHtmlObj = {
    creator: this.getProfileMenuHtml(
      currentUser,
      currentUserType,
      currentCreatorName,
      currentCreatorHandle,
      currentCreatorImageUrl
    ),
    brand: this.getProfileMenuHtml(
      currentUser,
      currentUserType,
      currentBrandName,
      currentBrandHandle,
      currentBrandImageUrl
    ),
    consumer: this.getProfileMenuHtml(
      currentUser,
      currentUserType,
      currentUserName,
      currentUserHandle,
      currentUserImageUrl
    ),
  };

  const profileHtml = profileHtmlObj[currentUserType];

  const searchBarHtml = this.state.searchBarVisible ? (
    <div
      ref={this.searchBarRef}
      className={`absolute w-full left-0 top-full bg-gray-100 search-bar-container p-3`}
    >
      {this.state.showError && (
        <div className="text-center text-xl font-bold mt-3 text-red-700">
          URL is invalid
        </div>
      )}

      {/* Search Tabs */}
      <SearchTabs 
        activeTab={this.state.searchMode} 
        onTabChange={(mode) => this.setState({
          searchMode: mode,
          searchQuery: "",
          ingredientsList: [],
          currentIngredient: ""
        })} 
      />

      {/* Regular Search Form */}
      {this.state.searchMode === "full" && (
        <form className="search-bar" onSubmit={(e) => e.preventDefault()}>
          <div className="input-container w-full flex flex-col sm:flex-row justify-center items-center">
            {this.state.loading ? (
              <div className="loading-icon">
                <img alt="" src="/loading.svg" />
              </div>
            ) : (
              <div className="flex flex-col lg:flex-row justify-center items-center w-full lg:w-auto">
                <div className="relative w-full lg:w-auto">
                  <textarea
                    id="textArea"
                    style={{
                      height: "50px",
                      width: "650px",
                      wordBreak: "break-word",
                      resize: "none",
                    }}
                    autoFocus
                    className=" hidden lg:block px-5"
                    placeholder={
                      this.state.searchMode === "full"
                        ? "Search anything, Search for specific ingredients, Enter a recipe URL."
                        : "Enter ingredients separated by commas (e.g., chicken, beans)"
                    }
                    value={
                      this.state.searchMode === "full"
                        ? this.state.searchQuery
                        : this.state.currentIngredient
                    }
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (this.state.searchMode === "full") {
                          this.handleSearchOnSubmit(e.target.value);
                        } else {
                          this.handleSearchByIngredients();
                        }
                      }
                    }}
                    onChange={(e) => {
                      if (this.state.searchMode === "full") {
                        this.setState({ searchQuery: e.target.value });
                      } else {
                        this.setState({ currentIngredient: e.target.value });
                      }
                    }}
                  />
                  <input
                    id="textInput"
                    type="text"
                    style={{
                      width: "100%",
                      maxWidth: "600px",
                      maxHeight: "300px",
                      display: window.innerWidth < 1024 ? "" : "none",
                    }}
                    autoFocus
                    className=" px-3 py-2 rounded-sm border border-gray-300 focus:ring-2 focus:ring-green-500 transition w-full"
                    placeholder={
                      this.state.searchMode === "full"
                        ? "Search anything, search for specific ingredients, or enter a recipe URL."
                        : "Enter ingredients separated by commas (e.g., chicken, beans)"
                    }
                    value={
                      this.state.searchMode === "full"
                        ? this.state.searchQuery
                        : this.state.currentIngredient
                    }
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        if (this.state.searchMode === "full") {
                          this.handleSearchOnSubmit(e.target.value);
                        } else {
                          this.handleSearchByIngredients();
                        }
                      }
                    }}
                    onChange={(e) => {
                      if (this.state.searchMode === "full") {
                        this.setState({ searchQuery: e.target.value });
                      } else {
                        this.setState({ currentIngredient: e.target.value });
                      }
                    }}
                  />
                </div>

                {/* Search Button for Desktop Only */}
                <div className="hidden lg:block">
                  <button
                    disabled={
                      this.state.searchMode === "full"
                        ? this.state.searchQuery === ""
                        : this.state.currentIngredient === ""
                    }
                    onClick={() => {
                      if (this.state.searchMode === "full") {
                        this.handleSearchOnSubmit(this.state.searchQuery);
                      } else {
                        this.handleSearchByIngredients();
                      }
                    }}
                    className="lg:ml-3 h-10 bg-[#0e4621] hover:bg-[#3e8e41] text-white px-4 rounded"
                  >
                    Search
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Keyword Suggestions for Full Search */}
          {this.state.searchMode === "full" && (
            <div className="hidden lg:block text-center bg-gray-100 px-4">
              <span style={{ opacity: "0.5" }}>Try these keywords</span>
              <div className="flex flex-col justify-center gap-2">
                <div className="mt-3">
                  <span
                    className="bg-gray-300 px-2 py-1 text-black rounded-[4px] cursor-pointer"
                    onClick={() => {
                      this.setState({ searchQuery: "Chicken ramen noodles" });
                    }}
                  >
                    <img
                      alt=""
                      src="/try-prompt.png"
                      className="inline h-4 mr-1 mb-1"
                    />
                    Chicken ramen noodles
                  </span>
                  <span
                    className="bg-gray-300 px-2 py-1 ml-4 text-black rounded-[4px] cursor-pointer"
                    onClick={() => {
                      this.setState({ searchQuery: "Raspberry crumble bars" });
                    }}
                  >
                    <img
                      alt=""
                      src="/try-prompt.png"
                      className="inline h-4 mr-1 mb-1"
                    />
                    Raspberry crumble bars
                  </span>
                </div>
                <div className="mt-3">
                  <span
                    className="bg-gray-300 px-2 py-1 text-black rounded-[4px] cursor-pointer"
                    onClick={() => {
                      this.setState({ searchQuery: "Chicken pot pie" });
                    }}
                  >
                    <img
                      alt=""
                      src="/try-prompt.png"
                      className="inline h-4 mr-1 mb-1"
                    />
                    Chicken pot pie
                  </span>
                </div>
              </div>
            </div>
          )}
        </form>
      )}

      {/* Kitchen Search Form - Enhanced UI */}
        {/* Kitchen Search Form - Enhanced UI */}
        {this.state.searchMode === "kitchen" && (
          <div className="max-w-2xl mx-auto mb-4">
            <form onSubmit={(e) => {
              e.preventDefault();
              this.handleSearchByIngredients();
            }} className="flex flex-col gap-4">
              {/* Input with Plus button */}
              <div className="relative flex mb-2">
                <input
                  type="text"
                  value={this.state.currentIngredient}
                  onChange={(e) => this.setState({ currentIngredient: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      // Add ingredient logic
                      if (this.state.currentIngredient.trim() !== "") {
                        const ingredientList = this.state.currentIngredient.split(',');
                        let newIngredients = [...this.state.ingredientsList];
                        
                        ingredientList.forEach(item => {
                          const trimmedItem = item.trim().toLowerCase();
                          if (trimmedItem !== "" && !newIngredients.includes(trimmedItem)) {
                            newIngredients.push(trimmedItem);
                          }
                        });
                        
                        this.setState({
                          ingredientsList: newIngredients,
                          currentIngredient: ""
                        });
                      }
                    }
                  }}
                  placeholder="Enter ingredients separated by commas (e.g., chicken, rice, onions)"
                  className="w-full px-4 py-2.5 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 transition-colors pr-20"
                  autoFocus
                />
                
                {/* File Upload Button */}
                <input
                  ref={this.fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={this.handleImageUpload}
                  className="hidden"
                  id="image-upload-menubar"
                />
                <label
                  htmlFor="image-upload-menubar"
                  className="absolute right-12 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-[#0e4621] p-2 transition duration-300 flex items-center justify-center cursor-pointer"
                  title="Upload image to identify ingredients"
                >
                  <FontAwesomeIcon icon={faPaperclip} size="sm" />
                </label>
                
                {/* Plus Button */}
                <button
                  type="button"
                  onClick={() => {
                    // Add ingredient logic
                    if (this.state.currentIngredient.trim() !== "") {
                      const ingredientList = this.state.currentIngredient.split(',');
                      let newIngredients = [...this.state.ingredientsList];
                      
                      ingredientList.forEach(item => {
                        const trimmedItem = item.trim().toLowerCase();
                        if (trimmedItem !== "" && !newIngredients.includes(trimmedItem)) {
                          newIngredients.push(trimmedItem);
                        }
                      });
                      
                      this.setState({
                        ingredientsList: newIngredients,
                        currentIngredient: ""
                      });
                    }
                  }}
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-[#0e4621] hover:text-[#0a3419] p-2 transition duration-300 flex items-center justify-center"
                >
                  <FontAwesomeIcon icon={faPlus} size="sm" />
                </button>
              </div>

              {/* Image Preview (only show if image is uploaded) */}
              {this.state.imagePreview && (
                <div className="mb-4 p-3 bg-gray-50 rounded-md">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <img
                        src={this.state.imagePreview}
                        alt="Uploaded ingredients"
                        className="w-12 h-12 rounded object-cover"
                      />
                      <div>
                        <p className="text-sm font-medium text-gray-700">Image uploaded</p>
                        <button
                          type="button"
                          onClick={this.handleAnalyzeImage}
                          disabled={this.state.isAnalyzingImage}
                          className="text-xs text-[#0e4621] hover:text-[#0a3419] disabled:opacity-50 underline"
                        >
                          {this.state.isAnalyzingImage ? "Analyzing image..." : "🔍 Scan for ingredients"}
                        </button>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={this.handleRemoveImage}
                      className="text-gray-400 hover:text-red-500 transition duration-300"
                    >
                      <FontAwesomeIcon icon={faClose} size="sm" />
                    </button>
                  </div>
                </div>
              )}
              
              {/* Ingredients Tags */}
              {this.state.ingredientsList.length > 0 && (
                <div className="mb-2">
                  <div className="flex flex-wrap gap-2">
                    {this.state.ingredientsList.map((ingredient, index) => (
                      <div key={index} className="bg-[#0e4621] text-white px-3 py-1.5 rounded-full flex items-center text-sm shadow-sm">
                        <span>{ingredient}</span>
                        <button 
                          type="button"
                          onClick={() => this.handleRemoveIngredient(index)}
                          className="ml-2 text-white hover:text-red-200 focus:outline-none"
                        >
                          <FontAwesomeIcon icon={faClose} size="xs" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Popular Ingredients Section */}
              <div className="bg-[#f7f9f8] border border-gray-100 rounded-md py-3 px-4 mt-2">
                <div className="flex justify-between items-center mb-2">
                  <p className="text-[#0e4621] font-medium">Popular ingredients</p>
                </div>
                <div className="flex flex-wrap gap-2">
                  {['chicken', 'tomato', 'onion', 'garlic', 'pasta', 'rice', 'potato', 'egg'].map((ingredient) => {
                    // Helper function to get color for ingredient buttons
                    const getIngredientColor = (ingredient) => {
                      const colors = [
                        'bg-[#e8f5ec] text-[#0e4621]', // Green
                        'bg-[#f0f5ff] text-[#1e40af]', // Blue
                        'bg-[#fff4e6] text-[#c05621]', // Orange
                        'bg-[#faf5ff] text-[#6b46c1]', // Purple
                        'bg-[#f0ffff] text-[#047481]'  // Teal
                      ];
                      
                      // Use string hashing to assign consistent colors
                      let hash = 0;
                      for (let i = 0; i < ingredient.length; i++) {
                        hash = ingredient.charCodeAt(i) + ((hash << 5) - hash);
                      }
                      
                      return colors[Math.abs(hash) % colors.length];
                    };
                    
                    const colorClass = getIngredientColor(ingredient);
                    
                    return (
                      <button
                        key={ingredient}
                        type="button"
                        onClick={() => {
                          if (!this.state.ingredientsList.includes(ingredient)) {
                            this.setState({
                              ingredientsList: [...this.state.ingredientsList, ingredient]
                            });
                          }
                        }}
                        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all hover:shadow-md ${
                          this.state.ingredientsList.includes(ingredient)
                            ? "bg-gray-200 text-gray-500 cursor-not-allowed opacity-60"
                            : `${colorClass} hover:opacity-90`
                        } flex items-center`}
                        disabled={this.state.ingredientsList.includes(ingredient)}
                      >
                        {ingredient}
                      </button>
                    );
                  })}
                </div>
              </div>
              
              {/* Search Button */}
              <button
                type="submit"
                disabled={this.state.ingredientsList.length === 0 && !this.state.currentIngredient || this.state.loading}
                className="w-full bg-[#0e4621] hover:bg-[#3e8e41] text-white py-2.5 rounded-md transition duration-300 flex items-center justify-center shadow-sm hover:shadow mt-3"
              >
                <FontAwesomeIcon icon={faSearch} className="mr-2" />
                <span className="font-medium">Find Recipes</span>
              </button>
              
              <p className="text-sm text-gray-600 mt-1">
                Enter ingredients you have to find recipes you can make.
              </p>
            </form>
          </div>
        )}
      </div>
    ) : (
      <></>
    );

    {/* Analysis Animation Overlay */}
    const analysisAnimationOverlay = this.state.showAnalysisAnimation ? (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-8 max-w-sm mx-4 text-center">
          <Player
            autoplay
            loop
            src={loader}
            style={{ height: '200px', width: '200px' }}
          />
          <div className="mt-4">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <FontAwesomeIcon icon={faMagicWandSparkles} className="text-[#0e4621] text-xl" />
              <h3 className="text-lg font-semibold text-gray-800">Analyzing Image</h3>
            </div>
            <p className="text-gray-600 text-sm">
              Identifying ingredients from your image...
            </p>
          </div>
        </div>
      </div>
    ) : null;

    function setViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    setViewportHeight();

    window.addEventListener("resize", setViewportHeight);

    const feedbackFormHtml = (
      <>
        <div
          className={clsx(["fixed inset-0 bg-gray-900 opacity-50 z-10"], {
            hidden: !this.state.isFeedbackFormVisible,
          })}
        ></div>
        <div
          className={clsx([
            "feedback-form fixed flex flex-col w-screen md:max-w-screen-sm md:p-4 justify-end transition-transform duration-500 left-1/2 -translate-x-1/2 rounded-xl z-[10]",
            [
              this.state.isFeedbackFormVisible
                ? "top-1/2 -translate-y-1/2"
                : "-translate-y-full",
            ],
          ])}
          style={{
            height: `calc(var(--vh, 1vh) * 100)`,
          }}
        >
          <iframe
            title="feedback-form"
            src="https://docs.google.com/forms/d/e/1FAIpQLSfRUn5864WlRJDxStwJ0PVnlIoS9Jym4LVZ_pHuq7-uP93nwg/viewform?usp=sf_link"
            width="100%"
            height="100%"
          >
            Loading…
          </iframe>
          {/* <p className='text-white'>Tell Us What You Think!</p>
                <input type="text" placeholder='Enter your email id' style={{
                    width: "100%"
                }}/>
                <textarea rows={4}></textarea> */}
          <div className="text-end mt-2 absolute right-4 bottom-4 lg:right-8 lg:bottom-8">
            {/* <button className='bg-[#ccc] text-black rounded-full px-4 py-2 mr-4' onClick={this.handleFeedbackButtonClick}>Cancel</button> */}
            <button
              className="bg-[#0e8880] text-[#fff] rounded-full lg:rounded-sm px-3 lg:px-4 py-1 lg:py-2"
              onClick={this.handleFeedbackButtonClick}
            >
              Close
            </button>
          </div>
        </div>
      </>
    );

    return (
      <>
        <header
          className={`${
            this.state.searchBarVisible ? "search-active" : null
          } fixed left-1/2 transform -translate-x-1/2 bg-[#0e4621] px-4 xl:px-12 py-2 z-10`}
        >
          <div
            className={clsx([
              "mobile-custom-menu flex flex-col cursor-pointer text-2xl fixed right-0 top-0 h-screen w-72 bg-[#0e4621] text-white shadow-lg z-50 transition-transform duration-500 lg:hidden",
              {
                "translate-x-full": !this.state.isMobileMenuVisible,
              },
            ])}
            onClick={this.handleLeftSideFixedMobileMenuClick}
          >
            <p className="fixed right-0 top-0 p-4 z-10">
              <X onClick={this.toggleMenu} />
            </p>
            {this.state.isMobile && (
              <div className="flex items-center lg:ml-auto">{profileHtml}</div>
            )}
            {mobileMenuItemsHtml}
          </div>
          <div className="flex flex-col lg:flex-row justify-between lg:items-center">
            <div className="flex justify-between items-center">
              <Link to="/">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    className="logo"
                    src="/Ladle_app_highres_rounded_square.png"
                    alt="Logo"
                  />
                </div>
              </Link>
              <div className="flex items-center">
                <Link
                  className="lg:hidden"
                  onClick={this.handleSearchOnClick}
                  ref={this.mobileSearchBtnRef}
                >
                  <FontAwesomeIcon
                    className="mr-2 text-white text-2xl"
                    icon={faSearch}
                  />
                </Link>
                <button
                  className="flex flex-col items-center justify-center w-10 h-8 space-y-2 rounded focus:outline-none lg:hidden"
                  onClick={this.toggleMenu}
                  ref={this.customMenuBtnRef}
                >
                  <span className="block w-6 h-0.5 bg-white"></span>
                  <span className="block w-6 h-0.5 bg-white"></span>
                  <span className="block w-6 h-0.5 bg-white"></span>
                </button>
              </div>
            </div>
            <div className="hidden lg:flex flex-col lg:flex-row items-center flex-grow justify-center lg:justify-between">
              <div className="custom-menu flex flex-col lg:flex-row items-center justify-center flex-grow flex-wrap">
                {menuItemsHtml}
              </div>
              {!this.state.isMobile && (
                <div className="flex items-center justify-end lg:ml-auto">
                  {profileHtml}
                </div>
              )}
              {config.ENABLE_ADD_RECIPE ? addContentButtonHtml : null}
            </div>
          </div>
          {searchBarHtml}
        </header>
        {feedbackFormHtml}
        {analysisAnimationOverlay}
      </>
    );
  }
}

export default MenuBar;
